import { render, staticRenderFns } from "./tickets-priority.vue?vue&type=template&id=558bcded&"
import script from "./tickets-priority.vue?vue&type=script&lang=js&"
export * from "./tickets-priority.vue?vue&type=script&lang=js&"
import style0 from "./tickets-priority.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports